/**
 * @generated SignedSource<<87faaa1bbe4769cbca56503d4e11c68c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_jqlBuilderWithAi_JQLBuilderWithAI$data = {
  readonly shouldShowAtlassianIntelligence: boolean | null | undefined;
  readonly userPreferences: {
    readonly " $fragmentSpreads": FragmentRefs<"main_jqlBuilder_JQLBuilder" | "naturalLanguageToJqlWrapper_jqlBuilderWithAi" | "spotlightTourContainer_jqlBuilderWithAi">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"naturalLanguageToggle_jqlBuilderWithAi">;
  readonly " $fragmentType": "ui_jqlBuilderWithAi_JQLBuilderWithAI";
};
export type ui_jqlBuilderWithAi_JQLBuilderWithAI$key = {
  readonly " $data"?: ui_jqlBuilderWithAi_JQLBuilderWithAI$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_jqlBuilderWithAi_JQLBuilderWithAI">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "atlassianIntelligenceProductFeature"
    },
    {
      "kind": "RootArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "ui_jqlBuilderWithAi_JQLBuilderWithAI",
  "selections": [
    {
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "feature",
              "variableName": "atlassianIntelligenceProductFeature"
            }
          ],
          "kind": "ObjectValue",
          "name": "atlassianIntelligenceProductFeatureInput"
        },
        (v0/*: any*/)
      ],
      "kind": "ScalarField",
      "name": "shouldShowAtlassianIntelligence"
    },
    {
      "kind": "FragmentSpread",
      "name": "naturalLanguageToggle_jqlBuilderWithAi"
    },
    {
      "args": [
        (v0/*: any*/)
      ],
      "concreteType": "JiraUserPreferences",
      "kind": "LinkedField",
      "name": "userPreferences",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "spotlightTourContainer_jqlBuilderWithAi"
        },
        {
          "kind": "FragmentSpread",
          "name": "naturalLanguageToJqlWrapper_jqlBuilderWithAi"
        },
        {
          "kind": "FragmentSpread",
          "name": "main_jqlBuilder_JQLBuilder"
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "ded14f441227ee258bb1f97921cfaf47";

export default node;
